const EMAIL_ADDRESS = /\b[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}\b/gi;

export const formatClientNotes = value => {
  if (value === null || value === undefined) return '';
  return String(value)
    .replace(EMAIL_ADDRESS, '')
    .replace(/<\s*>/g, '')
    .replace(/\[\s*\]\s*/g, '')
    .replace(/[ \t]+\]/g, ']')
    .replace(/(^|\n)[ \t]*:[ \t]*/g, '$1')
    .replace(/[^\S\r\n]{2,}/g, ' ')
    .trim();
};
